var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 430.5 154.8",
    style: {
      enableBackground: "new 0 0 430.5 154.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.2,59.8v38l26.5,12.8l91.6,0.1V47.2H62L35.2,59.8z M61.4,50.6v56.7l-16.5-8L42.2,98l0,0l-4.1-2V61.6 L61.4,50.6L61.4,50.6z M64.3,62.4l23.2,0v32.7l-23.2,0V62.4z M88.9,59.6H64.3v-9.5h72.8L88.9,59.6z M137.5,107.8H64.3V98l24.5,0 L137.5,107.8z M90.5,62.2l60-11.8v57.1l-60-12.1V62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M309.9,86.7c0,4.6-1,8.2-3,10.8c-2,2.6-4.8,3.9-8.3,3.9c-3.4,0-5.9-1.1-7.6-3.3c-1.7-2.2-2.6-5.5-2.6-9.9V63.8 h-10.5v25.4c0,7.4,1.7,12.9,5.1,16.3c3.4,3.4,7.9,5.1,13.3,5.1c5.7,0,10.4-1.9,13.9-5.8l1,5.3h9.2V63.8h-10.5V86.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M376.8,63.3c-3.7,0-7,0.7-9.7,2.2c-2.5,1.4-4.5,3.2-6.1,5.6c-1.3-2.5-3.2-4.4-5.5-5.7 c-2.5-1.4-5.4-2.1-8.7-2.1c-5.4,0.1-9.9,2.1-13.1,5.9l-1-5.4h-9.2v46.3h10.5V85.3c0-4,0.9-7.2,2.8-9.5c1.8-2.3,4.4-3.5,7.5-3.5 c3,0,5.3,1,6.9,2.9c1.6,2,2.4,4.9,2.4,8.8v26h10.6v-25c0-4,0.9-7.1,2.8-9.4c1.8-2.2,4.4-3.4,7.6-3.4c3,0,5.3,1,6.8,2.9 c1.5,2,2.3,4.9,2.3,8.8v26h10.5V84c0-7.2-1.6-12.5-4.8-15.8C386.1,64.9,381.9,63.3,376.8,63.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M251.9,66.2c-3.6-2-7.8-3-12.4-3c-4.6,0-8.8,1-12.4,3c-3.6,2-6.4,4.8-8.4,8.4c-2,3.6-3,7.7-3,12.3 c0,4.7,1,8.8,3,12.4c2,3.6,4.8,6.4,8.4,8.3c3.6,1.9,7.7,2.9,12.4,2.9c4.6,0,8.8-1,12.4-2.9c3.6-2,6.4-4.8,8.4-8.3 c2-3.6,3-7.7,3-12.4c0-4.6-1-8.7-3-12.3C258.3,71,255.5,68.2,251.9,66.2z M249,97.5c-2.4,2.7-5.6,4.1-9.5,4.1 c-3.9,0-7.1-1.4-9.4-4.1c-2.4-2.7-3.6-6.3-3.6-10.6c0-4.3,1.2-7.9,3.6-10.6c2.3-2.7,5.5-4.1,9.4-4.1c3.9,0,7.1,1.4,9.5,4.1 c2.4,2.7,3.6,6.3,3.6,10.6S251.4,94.8,249,97.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.8,
    y: 47.1,
    className: "st0",
    width: 10.5,
    height: 62.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "214,47.1 196.9,96.1 179.9,47.1 168.2,47.1 190.4,110.1 203.3,110.1 225.5,47.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "403.7,62.4 401.9,66.7 400.2,62.4 398.4,62.4 398.4,68.5 399.7,68.5 399.7,64.2 401.4,68.4  401.4,68.5 402.4,68.5 404.2,64.2 404.2,68.5 405.5,68.5 405.5,62.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "392.9,63.7 394.7,63.7 394.7,68.5 396.1,68.5 396.1,63.7 397.9,63.7 397.9,62.4 392.9,62.4  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.15e92374ba91bc83e85d72adf8bf4b3f.svg";
export { ForwardRef as ReactComponent };